// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const NO_RESULTS_CANCEL_SEARCH = "Zru\u0161 hled\u00e1n\u00ed";
